import OneSignalVuePlugin from '@onesignal/onesignal-vue3';
import { Plugin } from 'vue';


const OneSignalPlugin: Plugin =
{
    install(app) {
        const oneSignalAppId = import.meta.env.VITE_APP_ONESIGNAL;
        if (oneSignalAppId !== null && oneSignalAppId !== '') {
            OneSignalVuePlugin.install(app, {
                appId: oneSignalAppId,
                allowLocalhostAsSecureOrigin: !import.meta.env.PROD,
            });
        }
    }
};

export default OneSignalPlugin;
